/**
 * Modal 스타일
 * @description 표면은 `BottomSheet` 과 같은 피부(`3.0/shell/sheet`)다 — 배경 · 모서리 · 여백이
 *   같다. 다른 것은 자리뿐이다. 앱의 Modal 은 폰 바닥에 붙지만, 웹의 Modal 은 **넓은 화면의
 *   가운데**에 선다 — 바닥에 붙은 시트는 폰의 손이 닿는 자리이고, 마우스 화면에서 그 자리는
 *   눈에서 가장 먼 곳이다.
 */
export const modalStyles = {
  dialog: [
    "m-auto w-[calc(100%_-_var(--fw-space-inset-lg)*2)] max-w-[480px] bg-transparent p-0",
    "backdrop:bg-[var(--fw-color-effect-scrim)]",
  ].join(" "),
  surface:
    "relative flex max-h-[calc(100dvh_-_var(--fw-space-inset-xxl)*2)] flex-col rounded-[var(--fw-radius-xl)] bg-[var(--fw-color-surface-neutral-primary)] text-[var(--fw-color-content-neutral-primary)]",
  close:
    "absolute top-[var(--fw-space-inset-sm)] right-[var(--fw-space-inset-sm)]",
  body: "min-h-0 flex-1 overflow-y-auto px-[var(--fw-space-inset-xl)] pt-[var(--fw-space-inset-xxl)] pb-[var(--fw-space-inset-xl)]",
  footer: "px-[var(--fw-space-inset-xl)] pb-[var(--fw-space-inset-xl)]",
};
